import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Aggressive suppression of benign ResizeObserver error
const resizeObserverErrorFilter = (event) => {
  const resizeObserverError = [
    'ResizeObserver loop',
    'ResizeObserver loop completed with undelivered notifications',
    'ResizeObserver loop limit exceeded'
  ];
  
  if (event.message && resizeObserverError.some(err => event.message.includes(err))) {
    event.stopImmediatePropagation();
    event.preventDefault();
    console.warn('ResizeObserver notification suppressed (benign)');
    return true;
  }
  return false;
};

// Suppress error events
window.addEventListener('error', (event) => {
  resizeObserverErrorFilter(event);
}, true);

// Suppress unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message) {
    const errorEvent = { message: event.reason.message, stopImmediatePropagation: () => {}, preventDefault: () => {} };
    if (resizeObserverErrorFilter(errorEvent)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);